import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { OnboardingAnalysisTypeEnum } from '../enum/OnboardingAnalysisTypeEnum';

enum OnboardingServiceEnum {
  reprocess = "/reprocess"
}
export default class OnboardingService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/onboarding");
  }

  public reprocess = async (referenceTypeId: number, onboardingAnalysisType: OnboardingAnalysisTypeEnum) =>
    await this.POST(`${OnboardingServiceEnum.reprocess}/${referenceTypeId}/${onboardingAnalysisType}`, {});
}
